@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

@size: 16px;

.tooltip {
  height: @size;
}

.tooltip-icon {
  width: @size;
  height: @size;
  transform: none;
  fill: @fulfillment-planner--rate-third-party--fill-color;
}

.message-icon {
  width: 14px;
  height: 14px;
  transform: none;
  fill: var(--gold-500);
  margin-right: @space-4;
}
